import {
  Apps16Regular,
  Clock16Regular,
  Document16Regular,
  TaskListSquareLtr16Regular,
} from '@/components/Icon'

const ICONS = {
  documents: Document16Regular,
  apps: Apps16Regular,
  schedules: Clock16Regular,
  triggers: TaskListSquareLtr16Regular,
}

export function ThreadSearchFilterIcon({ id }) {
  const Icon = ICONS[id]
  return Icon ? <Icon /> : null
}
